import React, { useEffect, useState } from "react";
import { DashboardCommonPage } from "../../commonPage";
import { useTranslation } from "react-i18next";
import { FaArrowTrendUp } from "react-icons/fa6";
import { Col, Row } from "react-bootstrap";
import { Badges, Buttton, Modaal, Tabbles } from "../../components";
import { PiCalendar, PiFolderOpen, PiThumbsUp, PiTrash } from "react-icons/pi";
import { Commons } from "../../utilities";
import { FiPhoneCall } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor, actionPatient } from "../../redux/actions";
import { FaCaretRight } from "react-icons/fa";
import { LuFileSearch2, LuMessagesSquare } from "react-icons/lu";
import { useAlert } from "../../contexts";

const Dashboard = ({ loginData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [showModal4, setShowModal4] = useState(false);
    const [showModal5, setShowModal5] = useState(false);
    const [selectedAppointmentGuid, setSelectedAppointmentGuid] = useState(null);
    const formattedDate = Commons.formatDateWithOrdinal(new Date());
    useEffect(() => {
        dispatch(
            actionPatient.getAppointments(
                5,
                1,
                "",
                "",
                "",
                loginData?.userGuid,
                "",
                2,
                "",
                "",
                null,
                null,
                "EUR",
                loginData.timeZoneId,
                null,
                null,
                null,
                loginData?.languageId,
                [1, 2, 3],
                null
            )
        );

        dispatch(
            actionPatient.getRequestedAppointments(
                5,
                1,
                "",
                "",
                "",
                loginData.userGuid,
                "",
                1,
                "",
                "",
                null,
                null,
                "EUR",
                loginData.timeZoneId,
                null,
                null,
                null,
                loginData?.languageId,
                [1, 2, 3]
            )
        );

        dispatch(
            actionPatient.postGetChatAppointmentByPatient({
                RequestTimeZone: loginData.timeZoneId,
                currency: 'EUR',
                languageId: loginData?.languageId,
                patientGuid: loginData?.userGuid,
            })
        );
    }, [dispatch, loginData]);
    const getAppointmentsData = useSelector(
        (state) => state.patient.getAppointmentsData?.data
    );
    const getRequestedAppointmentsData = useSelector(
        (state) => state.patient.getRequestedAppointmentsData?.data
    );
    const postGetChatAppointmentByPatientData = useSelector(
        (state) => state.patient.postGetChatAppointmentByPatientData?.data
    );
    const postBookedAppointment = (
        appointment,
        openModal,
        chatAppointmentDetails,
        emergencyCall
    ) => {
        const credentials = {
            UserTimeZone: loginData.timeZoneId,
            UserCurrency: 'EUR',
            appointmentGuid: appointment.appointmentGuid,
            LanguageId: loginData.languageId,
        };

        if (emergencyCall) {
            dispatch(actionDoctor.postBookedEmergencyAppointment(credentials))
            setShowModal5(true)

        } else if (chatAppointmentDetails) {
            alert("Call")
            dispatch(
                actionPatient.getBookedChatDetails(credentials, (error, response) => {
                    if (error) {
                        if (error.data?.statusCode === 400) {
                            const validationErrors = error.data.error?.ValidationErrors || [];
                            validationErrors.forEach((validationError) => {
                                console.error(
                                    `${t("Field")}: ${validationError.Field} - ${t("Message")}: ${validationError.Message
                                    }`
                                );
                                showAlert(
                                    "danger",
                                    validationError.Message,
                                    `${t("Error")} : ${validationError.Field}`
                                );
                            });
                        } else {
                            showAlert("danger", t("Invalid_credentials"), `${t("Error")} !`);
                        }
                    } else if (response?.status === 200) {
                        setShowModal4(true);
                    }
                })
            );
        } else {
            alert("call")
            dispatch(
                actionPatient.postBookedAppointment(credentials, (error, response) => {
                    if (error) {
                        if (error.data?.statusCode === 400) {
                            const validationErrors = error.data.error?.ValidationErrors || [];
                            validationErrors.forEach((validationError) => {
                                console.error(
                                    `${t("Field")}: ${validationError.Field} - ${t("Message")}: ${validationError.Message
                                    }`
                                );
                                showAlert(
                                    "danger",
                                    validationError.Message,
                                    `${t("Error")} : ${validationError.Field}`
                                );
                            });
                        } else {
                            showAlert("danger", t("Invalid_credentials"), `${t("Error")} !`);
                        }
                    } else if (response?.status === 200) {
                        if (openModal) {
                            setShowModal2(true);
                        }
                    }
                })
            );
        }
    };

    const rightSide1 = (
        <>
            <Row className="exado-row1">
                <Col md={8}>
                    <h2 className="exado-title-nine">{t("appointments.appointments")}</h2>
                    <p className="exado-title-three ">{t("appointments.sub_title")}</p>
                </Col>
                <Col md={12}>
                    <Tabbles.TableBlk
                        headerIcon={<PiCalendar className="header-Icn" />}
                        heading={t("appointments.upcoming.page-heading")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/patient/appointment-upcoming"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all_appointments")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("clinics_name")}`,
                            `${t("doctor_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("patient_details")}`,
                            `${t("time_&_date")}`,
                            `${t("location")}`,
                            `${t("status")}`,
                            "EUR",
                            `${t("decline")}`,
                        ]}
                        data={getAppointmentsData?.result?.patientAppointments
                            ?.filter((appointment) => appointment.iAppointmentStatus === 2)
                            ?.map((appointment) => ({
                                [t("clinics_name")]: appointment.clinicName,
                                [t("doctor_name")]:
                                    appointment.doctorFirstName +
                                    " " +
                                    appointment.doctorLastName,
                                [t("medical_specialty")]: appointment.physicianServices,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <PiFolderOpen
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(appointment, true, false, false)
                                            }
                                        />
                                    </div>
                                ),
                                [t("time_&_date")]: (
                                    <>
                                        <div>
                                            {new Date(
                                                appointment.appointmentDateTime
                                            ).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </div>
                                        <div>
                                            {new Date(appointment.appointmentDateTime)
                                                .toLocaleDateString("en-GB")
                                                .replace(/\//g, " - ")}
                                        </div>
                                    </>
                                ),
                                [t("location")]: appointment.appointmentType,
                                [t("status")]: appointment.appointmentStatus,
                                EUR: appointment.amount,
                                [t("decline")]: (
                                    <PiTrash
                                        className="delIcon noVerify"
                                        onClick={() => {
                                            // postBookedAppointment(appointment, false, false, false);
                                            // setShowModal3(true);
                                            // setSelectedAppointmentGuid(appointment.appointmentGuid);
                                        }}

                                    />
                                ),
                            }))}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_pending_verification")}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col md={8}>
                    <h2 className="exado-title-nine">{t("appointment_requests")}</h2>
                    <p className="exado-title-three ">
                        {t("doctor.dashboard.appointment_request_info")}
                    </p>
                </Col>
                <Col md={12}>
                    <Tabbles.TableBlk
                        headerIcon={<PiCalendar className="header-Icn" />}
                        heading={t("appointments.requested.page-heading")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/patient/appointment-request"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all_appointments")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("clinics_name")}`,
                            `${t("doctor_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("patient_details")}`,
                            `${t("time_&_date")}`,
                            `${t("location")}`,
                            `${t("status")}`,
                            "EUR",
                            `${t("decline")}`,
                        ]}
                        data={getRequestedAppointmentsData?.result?.patientAppointments.map(
                            (appointment) => ({
                                [t("clinics_name")]: appointment.clinicName,
                                [t("doctor_name")]:
                                    appointment.doctorFirstName +
                                    " " +
                                    appointment.doctorLastName,
                                [t("medical_specialty")]: appointment.physicianServices,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <PiFolderOpen
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(appointment, true, false, false)
                                            }
                                        />
                                    </div>
                                ),
                                [t("time_&_date")]: (
                                    <>
                                        <div>
                                            {new Date(
                                                appointment.appointmentDateTime
                                            ).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </div>
                                        <div>
                                            {new Date(appointment.appointmentDateTime)
                                                .toLocaleDateString("en-GB")
                                                .replace(/\//g, " - ")}
                                        </div>
                                    </>
                                ),
                                [t("location")]: appointment.appointmentType,
                                [t("status")]: appointment.appointmentStatus,
                                EUR: appointment.amount,
                                [t("decline")]: (
                                    <PiTrash
                                        className="delIcon noVerify"
                                    // onClick={() => handleAcceptReject(appointment, false)}
                                    />
                                ),
                            })
                        )}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_pending_verification")}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col md={12}>
                    <h2 className="exado-title-nine">{t("Chats")}</h2>
                    <p className="exado-title-three ">
                        {t("doctor.dashboard.chat_request_info")}
                    </p>
                </Col>
                <Col lg={6}>
                    <Tabbles.TableBlk
                        headerIcon={<LuMessagesSquare className="header-Icn" />}
                        heading={t("chatPage.requested.pageHeading")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/doctor/chat-requested"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("patient_name")}`,
                            `${t("patient_details")}`,
                            `${t("decline")}`,
                        ]}
                        data={postGetChatAppointmentByPatientData?.result
                            ?.filter((item) => item.status === 1)
                            ?.slice(0, 1)
                            ?.map((chat) => ({
                                [t("patient_name")]: chat.patientName,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <LuFileSearch2
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(chat, true, true, false)
                                            }
                                        />
                                    </div>
                                ),
                                [t("decline")]: (
                                    <PiTrash
                                        className="delIcon noVerify"
                                    // onClick={() => {
                                    //     postBookedAppointment(appointment, false, false, false);
                                    //     setShowModal3(true);
                                    //     setSelectedAppointmentGuid(appointment.appointmentGuid);
                                    // }}
                                    />
                                ),
                            }))}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_upcoming_chats")}
                    />
                </Col>
                <Col lg={6} className="dash-col">
                    <Tabbles.TableBlk
                        headerIcon={<LuMessagesSquare className="header-Icn" />}
                        heading={t("chatPage.onGoing.pageHeading")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/doctor/chat-ongoing"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("doctor_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("patient_details")}`,

                            `${t("respond")}`,
                        ]}
                        data={postGetChatAppointmentByPatientData?.result
                            ?.filter((item) => item.status === 2)
                            ?.slice(0, 1)
                            ?.map((chat) => ({
                                [t("doctor_name")]: chat.doctorName,
                                [t("medical_specialty")]: chat.medicalSpeciality,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <LuFileSearch2
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(chat, true, true, false)
                                            }
                                        />
                                    </div>
                                ),

                                [t("respond")]: (
                                    <div className="editBlkIcon">
                                        <LuMessagesSquare
                                            className="editIcon"
                                            onClick={() =>
                                                navigate(
                                                    `/patient/chat-with-doctor/${chat?.appointmentGuid}`,
                                                    { state: { chat } }
                                                )
                                            }
                                        />
                                    </div>
                                ),
                            }))}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_ongoing_chats")}
                    />
                </Col>
            </Row>
        </>
    );

    return (
        <>
            <DashboardCommonPage
                loginData={loginData}
                rightSide1={rightSide1}
                userType={Commons.userType.patient}
            />


            <Modaal.PatientDetailsModal
                show={showModal2}
                onHide={() => setShowModal2(false)}
                loginData={loginData}
                setShowModal3={setShowModal3}
                setShowModal2={setShowModal2}
                setSelectedAppointmentGuid={setSelectedAppointmentGuid}
            />
            <Modaal.PatientDetailsModal
                show={showModal4}
                onHide={() => setShowModal4(false)}
                loginData={loginData}
                // setSelectedAppointmentGuid={setSelectedAppointmentGuid}
                chatAppointmentDetails={true}
            />

            <Modaal.CancelAppointmentModal
                show={showModal3}
                onHide={() => setShowModal3(false)}
                loginData={loginData}
                appointmentGuid={selectedAppointmentGuid}
                setSelectedAppointmentGuid={setSelectedAppointmentGuid}
                dashboard={true}
            />
        </>


    );
};

export default Dashboard;
